import { render, staticRenderFns } from "./deleteProforma.vue?vue&type=template&id=197de5e0&scoped=true&"
import script from "./deleteProforma.vue?vue&type=script&lang=js&"
export * from "./deleteProforma.vue?vue&type=script&lang=js&"
import style0 from "./deleteProforma.vue?vue&type=style&index=0&id=197de5e0&scoped=true&lang=scss&"
import style1 from "./deleteProforma.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./deleteProforma.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197de5e0",
  null
  
)

export default component.exports